module.exports = __webpack_public_path__ + "static/assets/7b97c5bb59e0139602708986bd21cfeb.gif";